import { capitilizeAll, RunCode, RunCodes } from "@theprelude/core";

export const frequencyWordsToIgnore = ["of", "the", "day", "month"];

export type Frequency =
  | "daily"
  | "weekly"
  | "monthly"
  | "smart"
  | "debug"
  | "run once"
  | "every monday"
  | "every tuesday"
  | "every wednesday"
  | "every thursday"
  | "every friday"
  | "every saturday"
  | "every sunday"
  | "first day of the month";

export const frequencies = new Map<RunCode, Frequency>([
  [RunCodes.DAILY, "daily"],
  [RunCodes.WEEKLY, "weekly"],
  [RunCodes.MONTHLY, "monthly"],
  [RunCodes.SMART, "smart"],
  [RunCodes.DEBUG, "debug"],
  [RunCodes.RUN_ONCE, "run once"],
  [RunCodes.MONDAY, "every monday"],
  [RunCodes.TUESDAY, "every tuesday"],
  [RunCodes.WEDNESDAY, "every wednesday"],
  [RunCodes.THURSDAY, "every thursday"],
  [RunCodes.FRIDAY, "every friday"],
  [RunCodes.SATURDAY, "every saturday"],
  [RunCodes.SUNDAY, "every sunday"],
  [RunCodes.MONTH_1, "first day of the month"],
]);

export const runCodes = new Map<Frequency, RunCode>([
  ["daily", RunCodes.DAILY],
  ["weekly", RunCodes.WEEKLY],
  ["monthly", RunCodes.MONTHLY],
  ["smart", RunCodes.SMART],
  ["debug", RunCodes.DEBUG],
  ["run once", RunCodes.RUN_ONCE],
  ["every monday", RunCodes.MONDAY],
  ["every tuesday", RunCodes.TUESDAY],
  ["every wednesday", RunCodes.WEDNESDAY],
  ["every thursday", RunCodes.THURSDAY],
  ["every friday", RunCodes.FRIDAY],
  ["every saturday", RunCodes.SATURDAY],
  ["every sunday", RunCodes.SUNDAY],
  ["first day of the month", RunCodes.MONTH_1],
]);

export const allRunCodes: RunCode[] = [...frequencies.keys()];

export const getFrequency = (runCode: RunCode) => {
  return capitilizeAll(
    frequencies.get(runCode) ?? "Unknown",
    frequencyWordsToIgnore,
  );
};
